export default __webpack_public_path__ + "3def1b3c7c42c365db790aafbe9272ad.svg";